import React from 'react';
import { Skeleton } from '../ui/skeleton';

export const NewsCardSkeleton = ({ variant = 'default' }) => {
  if (variant === 'featured') {
    return (
      <div className="relative aspect-[16/9] md:aspect-[21/9] rounded-lg overflow-hidden">
        <Skeleton className="w-full h-full" />
      </div>
    );
  }

  if (variant === 'horizontal') {
    return (
      <div className="flex gap-4">
        <Skeleton className="w-32 h-24 md:w-40 md:h-28 rounded-lg flex-shrink-0" />
        <div className="flex-1 space-y-2 py-1">
          <Skeleton className="h-3 w-20" />
          <Skeleton className="h-4 w-full" />
          <Skeleton className="h-4 w-3/4" />
          <Skeleton className="h-3 w-24 mt-2" />
        </div>
      </div>
    );
  }

  return (
    <div className="space-y-3">
      <Skeleton className="aspect-video rounded-lg" />
      <Skeleton className="h-3 w-20" />
      <Skeleton className="h-5 w-full" />
      <Skeleton className="h-5 w-4/5" />
      <Skeleton className="h-3 w-24" />
    </div>
  );
};

export const VideoCardSkeleton = () => {
  return (
    <div className="rounded-lg overflow-hidden bg-slate-800">
      <Skeleton className="aspect-video" />
    </div>
  );
};

export const TickerSkeleton = () => {
  return (
    <div className="h-10 bg-[#0F172A] flex items-center gap-8 px-4 overflow-hidden">
      {[...Array(5)].map((_, i) => (
        <div key={i} className="flex items-center gap-3">
          <Skeleton className="h-4 w-16 bg-slate-700" />
          <Skeleton className="h-4 w-20 bg-slate-700" />
          <Skeleton className="h-4 w-12 bg-slate-700" />
        </div>
      ))}
    </div>
  );
};
